import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, ArrowLeft } from 'lucide-react';

export default function StocktakeHistoryPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6" data-testid="stocktake-history-page">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/stocktaking/dashboard')} data-testid="back-btn">
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Clock className="h-6 w-6 text-slate-500" />
            Stocktake History
          </h1>
          <p className="text-sm text-muted-foreground">Browse completed and locked stocktake sessions</p>
        </div>
      </div>
      <Card>
        <CardContent className="py-16 text-center">
          <Clock className="h-16 w-16 mx-auto mb-4 text-slate-300" />
          <p className="text-lg font-medium text-muted-foreground">Coming Soon</p>
          <p className="text-sm text-muted-foreground mt-1">
            Stocktake history and audit trail will be available here once sessions are completed.
          </p>
          <Button variant="outline" className="mt-6" onClick={() => navigate('/stocktaking/sessions')}>
            View Active Sessions
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
